/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import vars from "Consts/vars";
import CardSearchBrand from "@fdn/card_search_brand";
import Pills from "Components/pills";

import handleLoadMoreLabel from "Helpers/loadMore";

const Mobile = (props) => {

	const prop = props;
	const limitData = 20;

	return (
		<div className="component-tab-brand">
			{
				prop.dataBrand?.data?.brands.length > 0 ? (
					<>

						<div className="component-tab-brand__section-title">
							<p className="component-tab-brand__title title-brand">Brands</p>
						</div>
						<Pills
							id="reviews-pills"
							className="fd-body-md-regular mb-5"
							data={prop.pillsData}
							onClick={prop.onClickPill}
							selected={prop.activePill}
						/>
						{prop.activePill === "product" ? (
							<>
								<div className="component-tab-brand__section-brand">

									{
										Array.isArray(prop.dataBrand?.data?.brands)
										&& prop.dataBrand?.data?.brands.map((data) => (
											<CardSearchBrand
												key={data?.id}
												isMobile={prop.isMobile}
												brokenImage={vars.BROKEN_IMAGE.square}
												brand={{
													name: data?.name ? data?.name : "-",
													slug: data?.slug ? data?.slug : "-",
													type: data?.type ? data?.type : "-",
													logo: data?.logo ? data?.logo : vars.no_image,
													url: `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${data?.type}/${data?.slug}`,
												}}
												width="150px"
												height="77px"
											/>

										))
									}
								</div>
								{
									prop.dataBrand?.data?.brands.length < prop.dataBrand?.pagination?.total && (
										<div className="component-tab-brand__section-more-data">
											<button
												type="button"
												className="component-tab-brand__title-more-data"
												onClick={prop.handleLoadMoreBrand}
												id="id-loadmore"
											>
												{handleLoadMoreLabel({
													page: prop.dataBrand?.pagination.page,
													limit: limitData,
													total: prop.dataBrand?.pagination.total,
													data: prop.dataBrand?.data?.brands,
													text: "Brands",
												})}
											</button>
										</div>
									)
								}
							</>
						) : (

							<>
								<div className="component-tab-brand__section-brand">

									{
										prop.dataBrandService?.data?.brands.map((data) => (
											<CardSearchBrand
												key={data?.id}
												isMobile={prop.isMobile}
												brokenImage={vars.BROKEN_IMAGE.square}
												brand={{
													name: data?.name ? data?.name : "-",
													slug: data?.slug ? data?.slug : "-",
													type: data?.type ? data?.type : "-",
													logo: data?.logo ? data?.logo : vars.no_image,
													url: `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${data?.type}/${data?.slug}`,
												}}
												width="150px"
												height="77px"
											/>

										))
									}
								</div>
								{
									prop.dataBrandService?.data?.brands.length
									< prop.dataBrandService?.pagination?.total
										? (
											<div className="component-tab-brand__section-more-data">
												<button
													type="button"
													className="component-tab-brand__title-more-data"
													onClick={prop.handleLoadMoreBrandService}
													id="id-loadmore"
												>
													{handleLoadMoreLabel({
														page: prop.dataBrand?.pagination.page,
														limit: limitData,
														total: prop.dataBrand?.pagination.total,
														data: prop.dataBrand?.data?.brands,
														text: "Brands",
													})}
												</button>
											</div>
										) : ""
								}

							</>
						)}
					</>
				)
					: (
						<div className="component-tab-brand__section-image-error">
							<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-brand__image-error" />
							<h4 className="component-tab-brand__title">Sorry, no result found</h4>
							<p className="component-tab-brand__sub_title">Please try another keyword!</p>
						</div>
					)
			}
			<style jsx>
				{`
						.component-tab-brand{
							padding-top: 10px;
							max-width: 1280px;
							margin: auto;
						}
						.component-tab-brand__section-title{
							display: flex;
							margin-bottom: 22px;
							margin-top: 16px;
							justify-content: space-between;
						}
						.component-tab-brand__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.component-tab-brand__section-brand{
							display: grid;
							grid-template-columns: repeat(2,1fr);
							gap: 25px;
						}
						.component-tab-brand__section-image-brand{
							height: 75px;
							width: 150px;
						}
						.component-tab-brand__section-link-image-brand{
							display: flex;
							height: 100%;
						}
						.component-tab-brand__image-brand{
							max-height: 100%;
							max-width: 100%;
							margin: auto;
							display: flex;
						}
						.component-tab-brand__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.component-tab-brand__section-more-data{
							display: flex;
    						justify-content: center;
						}
						.component-tab-brand__title-more-data{
							font-family: 'Creato Display', sans-serif;
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							text-align: center;
							padding: 8px 16px;
							background: #fff;
							border: 1px solid #000;
							border-radius: 8px;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
							width: 100%;
						}
						.component-tab-brand__section-more-data{
							margin-top: 20px;
						}
						.component-tab-brand__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-brand__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;
						}
						.component-tab-brand__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-brand__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Mobile;
